import React, { Fragment, useEffect, useState } from 'react';

import Block from '../../../Scafolding/Block';
import { TextHeader, TextTitle } from '../../../Digital/TextHeaders';

import { Container, Row, Col, Table, FormGroup, Button, Label, Input, Alert, ListGroup, ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTrash } from '@fortawesome/free-solid-svg-icons';
import { SSDComps } from '../../../../Brands/SSD/Start'; 
import CompsAPI from '../Shared/DataCompAPI';
import Common from '../../../../Shared/Common';

export const Comps_ClubRecords = (props) => {
    return (
        <SSDComps>
            <Comps_ClubRecordsContent />
        </SSDComps>
    );
}   
export default Comps_ClubRecords;

export const Comps_ClubRecordsContent = (props) => {

    const [initalLoad, setInitialLoad] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [clubResults, setClubResults] = useState([]);
    const [filteredData, setFilteredData] = useState(clubResults);

    useEffect(() => {

        if (!initalLoad) {
            CompsAPI.getClubRecords({}, clubResultsCallback);
        }

        if (initalLoad) {
            const results = clubResults.filter(item =>
            {
                if ((!searchTerm) || (searchTerm.length == 0))
                    return true;

                if (item.fishSpeciesShort) {
                    var result = (item.fishSpeciesShort.toLowerCase().includes(searchTerm.toLowerCase()));
                    if (result)
                        return true;
                }

                if (item.diver) {
                    var result = (item.diver.toLowerCase().includes(searchTerm.toLowerCase()));
                    if (result)
                        return true;
                }

                if (item.location) {
                    var result = (item.location.toLowerCase().includes(searchTerm.toLowerCase()));
                    if (result)
                        return true;
                }
            }
            );
            setFilteredData(results);
        }

    }, [searchTerm]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    let clubResultsCallback = (data) => {
        setInitialLoad(true);

        setClubResults(data);
        setFilteredData(data);
    };

    let reset = () => { setSearchTerm(''); };

    return (
        <Block name="Records" isAlt={false}>

            <TextHeader 
                text={"Club Competion Results over the years"}
            />

            <Row>
                <Col lg="6">
                    <input
                        type="text"
                        placeholder="Search by Fish Species, Diver or location..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ padding: '8px', marginBottom: '16px', width: '300px' }}
                    />
                    {' '}
                    <Button color="danger" onClick={reset}>
                        <FontAwesomeIcon icon={faTrash} /> Reset
                    </Button>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Table striped hover borderless>
                        <thead>
                            <tr>
                                <th colspan="2">
                                    Fish Species
                                </th>
                                <th>
                                    Diver
                                </th>
                                <th>
                                    Weight
                                </th>
                                <th>
                                    Date
                                </th>
                                <th colspan="2">
                                    Location
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((entry, entryIndex) =>
                                <tr key={entryIndex}>
                                    <td>
                                        <span>{entry.fishSpeciesShort}</span>
                                    </td>
                                    <td>
                                        <span>{entry.fishSpeciesLong}</span>
                                    </td>
                                    <td>
                                        <span>{entry.diver}</span>
                                    </td>
                                    <td>
                                        <span>{entry.weight}</span>
                                    </td>
                                    <td>
                                        <span>{entry.catchdate}</span>
                                    </td>
                                    <td>
                                        <span>{entry.location}</span>
                                    </td>
                                    <td>
                                        <span>{entry.locationCategory}</span>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>

        </Block>
    );
}
